export default "__VITE_ASSET__BlcpejL___"